import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class CustomerService {
    constructor(http) {
        this.http = http;
        this.singular = 'customer';
        this.plural = 'customers';
        this.editor = PLATFORM.moduleName('pages/quote-setup/customers/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`customers/filter/${loadOptions}`);
        return await response.json();
    }

    async create(customer) {
        await this.http.fetch('customers', { method: 'POST', body: json(customer) });
    }

    async update(customer) {
        await this.http.fetch(`customers/${customer.id}`, { method: 'PUT', body: json(customer) });
    }

    async delete(id) {
        await this.http.fetch(`customers/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`customers/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`customers/top-three/${query}`);
        return await response.json();
    }
}